import { mutations, actions } from "./actions";

const state = {
    limit: true, // 구독학교 보기 3개 리밋
    token: null,
    user: {
        id: null,
        name: null,
        phoneNumber: null,
        userType: 0
    },
    unreadCount: 0,
    reLoading: false,

    // re password modal
    passwordToggle: false,

    // message
    messages: [],
    messageLoading: false,
    isLast: false,

    page: 1,
    schools: [],
    schoolsLoading: false
};

const getters = {
    sideSchools(state) {
        const todos = state.limit ? state.schools.slice(0, 3) : state.schools;

        return {
            count: state.schools.length,
            todos
        };
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
